
import { defineComponent, onBeforeMount, ref } from 'vue';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { invokeReviewerReport } from '@/utils/admin/harvest_report';
// eslint-disable-next-line
// import router from '@/router';
// import { XIcon } from 'vue-feather-icons';

export default defineComponent({
  name: 'ReviewerReport',
  setup() {
    const userRole = ref();
    const errorMessage = ref();
    const successMessage = ref();
    const showScreen = ref(true);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const triggerReviewerReport = async () => {
      await invokeReviewerReport('/admin/report/NR');
      successMessage.value = 'The report is being processed. You should get that over email in next 15 minutes';
      setTimeout(() => {
        successMessage.value = null;
      }, 6000);
    };

    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        console.log('inside length');
        if (userRole.value.includes('System Admin') || userRole.value.includes('Proxy Admin') || userRole.value.includes('Community Manager')) {
          showScreen.value = true;
        } else {
          showScreen.value = false;
        }
      }
    });
    return {
      showScreen,
      triggerReviewerReport,
      errorMessage,
      successMessage,
    };
  },
});
